import { styled } from '@mui/material';

export const CodeStyled = styled('code')(({ theme }) => ({}));
